<template>
  <div class="launch">
    <div class="spinner-wrapper">
        <div class="spinner">
            <div class="bounce1"></div>
            <div class="bounce2"></div>
            <div class="bounce3"></div>
        </div>
    </div>

    <nav-section></nav-section>

    <div id="launch-page" class="flex-container" style="margin: 75px 0 0 0">
        <div class="flex-full launch-header">
           <div class="flex-container flex-center kickstarter">
               <div>FUNDED ON</div>
               <div><img class="kickstarter-image" src="../assets/images/kickstarter.png"/></div>
               <div>IN 19 MINUTES</div>
           </div>
           <div class="flex-container-col flex-center">
               <div class="tagline">Put Your Dice To Work</div>
               <div class="available">Hardwood Spell Trackers - AVAILABLE 4/3/21</div>
           </div>
           <div class="flex-container-col flex-center">
               <div class="email-box" :hidden="success">
                    
                    <div class="email-field-container">
                        <div class="input-group mb-3">
                            <input v-model="email" v-bind:class="[email ? 'notEmpty' : '']" ref="email" type="text" class="form-control email-collect" placeholder="email address" aria-label="email address" aria-describedby="button-addon2">
                            <button @click="storeEmail" class="btn btn-outline-secondary email-button" type="button" id="button-addon2">Submit</button>
                        </div>
                    </div>
                    <div :hidden="!error" class="error-text">An error occurred, it your email a valid format?</div>
               </div>
               <div class="email-box" :hidden="!success">
                   <div class="available">Thank you for signing up for our updates!</div>
               </div>
           </div>
        </div>
    </div>
    <div class="flex-container flex-full flex-center arcane-logo">
        <div><img style="width:200px;" src="../assets/images/launch/Arcane_Logo_Full.png"/></div>
    </div>
    <div class="flex-container flex-full flex-center">
        <span class="scroll-down">Scroll Down for More <i class="fas fa-arrow-down"/></span>
    </div>
    
    <div class="product-highlight">
        <div class="flex-container flex-center">
            <div class="product-header">Hardwood Spell Trackers</div>
        </div>
        <div class="flex-container flex-center flex-wrap">
            <div class="product" v-for="item in spell_trackers" :key="item.image">
                <img class="product-width" :src="item.image"/>
                <br/>
                <span>{{item.hover}}</span>
            </div>
        </div>
        <div class="flex-container flex-center" style="padding-top:1em;">
            <div>
                <img class="explain-image" src="../assets/images/launch/tracker_call_outs.jpg"/>
            </div>
        </div>
    </div>

    <div class="kickstarter-title">
        <div class="flex-container flex-center">
            <div><img class="kickstarter-large" src="../assets/images/kickstarter.png"/></div>
        </div>
        <div class="flex-container flex-center kickstarter-section">
            <div id="counter">
                <div class="cell">
                    <div class="counter-value number-count" data-count="250">1</div>
                    <p>Backers</p>
                </div>
            </div>
            <div>
                <div class="form-group">
                    <button @click="goToKickstarter" type="button" class="btn-solid-lg invert">Visit</button>
                </div>
            </div>
            <div id="counter">
                <div class="cell">
                    <div class="counter-value number-count" data-count="19">1</div>
                    <p>Minutes To Fund</p>
                </div>
            </div>
        </div>
    </div>

    <div class="dice-highlight">
        <div class="flex-container-col flex-center">
            <div class="product-header">Who Doesn't Want More Dice?</div>
            <div class="dice-offer">Each Tracker has the option of adding an RPG set and or 9 D6 (while supplies last)</div>
            <div class="die-hard-logo">
                <img style="width:300px;" src="../assets/images/launch/Die_Hard_Logo.png"/>
            </div>
        </div>
        <div class="flex-container flex-center flex-wrap">
            <div class="product" v-for="item in dice" :key="item.image">
                <img class="product-width" :src="item.image"/>
                <br/>
                <span>{{item.hover}}</span>
            </div>
        </div>
    </div>

    <div class="customer-reviews">
        <div class="flex-container-col flex-center">
            <div class="product-header">
                Customer Reviews
            </div>
            <div>
                <carousel :per-page="1" :mouse-drag="true" :autoplay="true" :loop="true" :autoplayTimeout="6000" :paginationEnabled="false">
                    <slide v-for="item in reviews" :key="item.user">
                        <div class="review-card">
                            <div class="review-card-body">
                                <p class="testimonial-text">{{item.review}}</p>
                                <p class="testimonial-author">- {{item.user}}</p>
                                <i class="fas fa-star card-icon-user"></i><i class="fas fa-star card-icon-user"></i><i class="fas fa-star card-icon-user"></i><i class="fas fa-star card-icon-user"></i><i class="fas fa-star card-icon-user"></i>
                            </div>
                        </div>
                    </slide>
                </carousel>
            </div>
        </div>
    </div>

    <div class="social-highlight">
        <div class="flex-container-col flex-center">
            <div class="product-header">Social Media Shares</div>
        </div>
        <div class="flex-container flex-center flex-wrap">
            <div class="product" v-for="item in social" :key="item.image">
                <img class="social-image" :src="item.image"/>
            </div>
        </div>
    </div>

    <div class="flex-container-col flex-center">
        <div class="email-box" :hidden="success">
            <div class="email-text">Get reminded about this and future product releases</div>
            <div class="email-field-container">
                <div class="input-group mb-3">
                    <input v-model="email" v-bind:class="[email ? 'notEmpty' : '']" type="text" class="form-control email-collect" placeholder="email address" aria-label="email address" aria-describedby="button-addon2">
                    <button @click="storeEmail" class="btn btn-outline-secondary email-button" type="button" id="button-addon2">Submit</button>
                </div>
            </div>
        </div>
        <div class="email-box" :hidden="!success">
            <div class="available">Thank you for signing up for our updates!</div>
        </div>
    </div>

    <copyright-section></copyright-section>
  </div>
</template>

<script>
import NavSection from './NavSection'
import CopyrightSection from './CopyrightSection'
import api from '@/api'

export default {
  name: 'Launch4321Page',
  created: function () {
    window.location.href = 'https://shop.arcanespectacles.com/'
  },
  mounted() {
    const emailRef = this.$refs.email;
    emailRef.focus();
  },
  methods: {
    goToKickstarter () {
        window.open('https://www.kickstarter.com/projects/arcanespectacles/arcane-spectacles-hardwood-spell-trackers', '_blank');
    },
    isEmailValid() {
        return (this.email == "")? false : (this.reg.test(this.email)) ? true : false;
    },
    storeEmail () {
        if(this.isEmailValid()) {
            api.postEmail(this.email)
            this.success = true
            this.error = false
        }
        else {
            this.error = true
        }
    }
  },
  data () {
    return {
        email: undefined,
        reg: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/,
        success: false,
        error: false,
        spell_trackers: [
            {
                'image': require('../assets/images/launch/st_blackwalnut.jpg'),
                'hover': 'Black Walnut'
            },
            {
                'image': require('../assets/images/launch/st_bloodwood.jpg'),
                'hover': 'Bloodwood'
            },
            {
                'image': require('../assets/images/launch/st_cherry.jpg'),
                'hover': 'Cherry'
            },
            {
                'image': require('../assets/images/launch/st_maple.jpg'),
                'hover': 'Maple'
            },
            {
                'image': require('../assets/images/launch/st_monkeypod.jpg'),
                'hover': 'Monkey Pod'
            },
            {
                'image': require('../assets/images/launch/st_padauk.jpg'),
                'hover': 'Padauk'
            },
            {
                'image': require('../assets/images/launch/st_purpleheart.jpg'),
                'hover': 'Purple Heart'
            },
            {
                'image': require('../assets/images/launch/st_sapele.jpg'),
                'hover': 'Sapele'
            }
        ],
        dice: [
            {
                'image': require('../assets/images/launch/rpg_mischief.jpg'),
                'hover': 'Avalore Mischief'
            },
            {
                'image': require('../assets/images/launch/rpg_deepblue.jpg'),
                'hover': 'Avalore Deep Blue'
            },
            {
                'image': require('../assets/images/launch/rpg_samhain.jpg'),
                'hover': 'Avalore Samhain'
            },
            {
                'image': require('../assets/images/launch/rpg_seawitch.jpg'),
                'hover': 'Avalore Sea Witch'
            },
            {
                'image': require('../assets/images/launch/d6_mischief.jpg'),
                'hover': '9 D6 - Avalore Mishief'
            },
            {
                'image': require('../assets/images/launch/d6_deepblue.jpg'),
                'hover': '9 D6 - Avalore Deep Blue'
            },
            {
                'image': require('../assets/images/launch/d6_samhain.jpg'),
                'hover': '9 D6 - Avalore Samhain'
            },
            {
                'image': require('../assets/images/launch/d6_seawitch.jpg'),
                'hover': '9 D6 - Avalore Sea Witch'
            }
        ],
        reviews: [
            {
                review: "This spell slot tracker is just brilliant. Use my spare d6s to keep track of spells for my Sorcerer, while having my casting palette in the upper right and my full set in the bottom bar for use. Excellent little tool and prop for play sessions.",
                user: "Ben"
            },
            {
                review: "Amazing product! It looks even better in person than it did online. I am 100% recommending these fine folx to every tabletop gamer I know.",
                user: "Jess"
            },
            {
                review: "I LOVE IT! It fits both sets that I use for my wizard 💜 Seriously thinking of buying a couple more for some of the other spell casters in my own campaign.",
                user: "Sooz"
            },
            {
                review: "I have to admit, this is cool. I play D&D regularly and this is a great addition for any caster class, not to mention it's well put together and detailed! I'll definitely be shopping again, turn around time was fantastic!",
                user: "Michael"
            },
            {
                review: "Super cool and easy way for me to keep track and to show off some of my favorite dice! My husband and I love them!!!",
                user: "Heather"
            },
            {
                review: "These Spell Slot trackers are absolutely gorgeous! Would absolutely recommend this product to any TTRPG lovers out there. Also I love how they are lightweight so I can travel with them easier!",
                user: "Emmy"
            }
        ],
        social: [
           {image: require('../assets/images/launch/social/social_1.jpg')},
           {image: require('../assets/images/launch/social/social_2.jpg')},
           {image: require('../assets/images/launch/social/social_3.jpg')},
           {image: require('../assets/images/launch/social/social_4.jpg')},
           {image: require('../assets/images/launch/social/social_5.jpg')},
           {image: require('../assets/images/launch/social/social_6.jpg')},
           {image: require('../assets/images/launch/social/social_7.jpg')},
           {image: require('../assets/images/launch/social/social_8.jpg')},
           {image: require('../assets/images/launch/social/social_9.jpg')},
           {image: require('../assets/images/launch/social/social_10.jpg')},
           {image: require('../assets/images/launch/social/social_11.jpg')},
        ]
    }
  },
  components: {
    NavSection,
    CopyrightSection
  }
}
</script>

<style>
.launch {
    background-color: black;
}
.flex-container > div {
    padding: 5px;
}
.flex-container {
  display: flex;
  flex-direction: row;
}
.flex-container-col {
  display: flex;
  flex-direction: column;
}
.flex-wrap {
    flex-wrap: wrap;
}
.flex-full {
    flex-grow: 1;
}
.flex-center {
    justify-content: center;
}
.launch-header {
    padding: 2em !important;
    background-image: url('../assets/images/launch/4321_Header2.jpg');
    background-color: black;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    height: 900px;
    width: 100%;
}
.kickstarter {
    font-size: 1.4em;
    font-weight: bold;
    align-items: center;
}
.tagline {
    padding-top: 5.2em;
    font-size: 6em;
    font-weight: bold;
}
.available {
    padding-top: 2em;
    font-size: 1.2em;
    font-weight: bold;
}
.email-collect {
	width: 50% !important;
	padding-top: 0.75em;
	padding-bottom: 0.75em;
	padding-left: 0.75em;
	border: 2px solid #31DAD6;
	border-radius: 0.25rem;
	background-color: #413d52;
	color: #f1f1f8;
	font: 400 0.875rem/1.875rem "Open Sans", sans-serif;
	transition: all 0.2s ease;
	-webkit-appearance: none; /* removes inner shadow on form inputs on ios safari */
}
.email-collect:focus {
	border: 2px solid #31DAD6;
	outline: none; /* Removes blue border on focus */
    background-color: #413d52;
    color: #f1f1f8;
}

.email-collect:hover {
	border: 2px solid #31DAD6;
    background-color: #413d52;
    color: #f1f1f8;

}
.email-button {
    background-color: #31DAD6;
    color: #f1f1f8;
    font-size: 1.4em;
    font-weight: bold;
    padding: 0 2em;
}
.email-box {
    padding-top: 3em;
    padding-bottom: 3em;
    width:50%;
    align-self: center;
}
.email-field-container {
    align-self: center;
}
.email-text {
    font-size: 1.2em;
    text-align: left;
    padding: 1em;
}
.product-highlight {
    padding: 4em;
    background-color: white;
    color: #000;
}
.product-header {
    margin-bottom: 1em;
    font-size: 3em;
    font-family: 'Quando', Helvetica, Arial, sans-serif !important;
    line-height: 1.5em;
}
.product > span {
    font-size: 1.5em;
    font-family: 'Quando', Helvetica, Arial, sans-serif !important;
}
.kickstarter-title {
    padding: 1em 0 0 0;
    background-color: white;
}
.kickstarter-section {
    background-color: #05ce78;
    color: white;
    font-size: 3em;
    margin-top: 0.5em;
    padding: 0.25em 0 0 0;
    justify-content: space-around;
}
.counter-value {
    font-size: 1em;
}
.kickstart-button-container {
    background-color: #05ce78;
}
.kickstarter-section > div {
    width: 500px;
    align-self: center;
}
.thanks-text {
    font-size: 68px;
    padding-bottom: 1em;
    font-weight: bold;
    line-height: 0.8em;
}
.dice-offer {
    margin-bottom: 1em;
    font-size: 2em;
}
.die-hard-logo {
    background-color: #C0C0C0;
    padding:1em;
}
.dice-highlight {
    padding: 6em;
    background-color: white;
    color: #000;
}
.customer-reviews {
    background-color: #5B497B;
    color: white;
    padding: 1em;
}
.social-highlight {
    padding: 2em;
    background-color: white;
    color: #000;
}
.kickstarter-image {
    width:300px; 
    padding-bottom:0.5em;
}
.arcane-logo {
    background-color: black;
    padding-bottom:2em;
    margin-top: -10em;
}
.product-width {
    width:400px;
}
.explain-image {
   width:800px;
}
.kickstarter-large {
    width:500px;
    padding-bottom:0.5em;
}
.social-image {
    width:150px;
}
.error-text {
    color: red;
    text-align: left;
}
@media (max-width: 500px) {
	.kickstarter-image {
        width:150px; 
        padding-bottom:0.5em;
    }
    .kickstarter {
        font-size: 0.75em;
        margin-top: -2em;
    }
    .launch-header {
        margin: 2em 0 !important;
        padding: 2em 0 !important;
        height: 450px;
        width: 500px;
        background-color: black;
        background-position: center;
        background-repeat: no-repeat;
        background-size: cover;
    }
    .tagline {
        padding-top: 8em;
        font-size: 2em;
    }
    .available {
        padding-top: 1em;
        font-size: 1em;
    }
    .email-collect {
        width: 50% !important;
    }
    .email-button {
        padding: 0 1em;
    }
    .email-box {
        width:90%;
        padding-top: 2em;
    }
    .email-text {
        font-size: 0.9em;
    }
    .arcane-logo {
        padding:3em 0;
        margin-top: 0;
    }
    .product-header {
        margin-bottom: 1em;
        font-size: 2em;
        font-family: 'Quando', Helvetica, Arial, sans-serif !important;
        line-height: 1.5em;
    }
    .product-width {
        width:150px;
    }
    .explain-image {
        width:375px;
    }
    .kickstarter-large {
        width:325px;
        padding-bottom:0.5em;
    }
    .kickstarter-section {
        font-size: 1em;
        margin-top: 0.5em;
        padding: 1em 0 0 0;
    }
    .invert {
        padding: 1rem 3rem 1rem 3rem !important;
        font-size: 0.75em;
    }
    .dice-highlight {
        padding: 2em;
    }
    .dice-offer {
        margin-bottom: 1em;
        font-size: 1em;
    }
    .social-highlight {
        padding: 2em 0;
        background-color: white;
        color: #000;
    }
    .social-image {
        width:150px;
    }
    .product-highlight {
        padding: 2em 1em;
    }
    .dice-highlight {
        padding: 2em 1em;
    }
    .product > span {
        font-size: 0.75em;
    }
}
</style>


// WEBPACK FOOTER //
// src/components/Launch4321Page.vue